import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-5c6afb27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__content" }
const _hoisted_2 = { class: "left_upload_img tw-mb-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Upload images and files.", -1))
const _hoisted_4 = { class: "upload__area" }
const _hoisted_5 = { class: "uploade-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Drag and drop documents, or"),
    /*#__PURE__*/_createElementVNode("span", null, "Browse")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error_msg tw-text-red-500"
}
const _hoisted_8 = { class: "image__upload__wrapper" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uploaded Files", -1))
const _hoisted_11 = { class: "uploaded_details_wrapper" }
const _hoisted_12 = { class: "prop_img_details" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "upload__list" }
const _hoisted_15 = {
  key: 1,
  class: "blank_project"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your added project attachments will show up here", -1))
const _hoisted_17 = { class: "footer-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "832px",
    "max-width": "100%",
    persistent: "",
    className: ['phaseproof__upload__modal']
  }, {
    body: _withCtx(() => [
      _createVNode(_component_v_icon, {
        icon: "mdi-close",
        class: "close__icon",
        onClick: $setup.onClickToggleAttachmentModal
      }, null, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_file_input, {
                class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                label: "Upload",
                modelValue: $setup.imageValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.imageValue) = $event)),
                clearable: $setup.imageUrl ? true : false,
                "append-inner-icon": "mdi-image-plus",
                variant: "solo-filled",
                onChange: $setup.onFileChange,
                "onClick:clear": $setup.clearImageUrl,
                multiple: ""
              }, null, 8, ["modelValue", "clearable", "class", "onChange", "onClick:clear"]),
              _createVNode(_component_v_img, {
                class: "uploaded-img",
                width: 200,
                "aspect-ratio": "16/9",
                cover: "",
                src: $setup.imageUrl
              }, null, 8, ["src"])
            ]),
            _hoisted_6
          ]),
          ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($setup.errorMessage), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          ($setup.attachmentDataList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_form, {
                    rules: $setup.validation,
                    ref: "attachmentFormRef"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.attachmentDataList, (attachment, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "show_uploaded_details",
                          key: index
                        }, [
                          _createVNode(_component_v_img, {
                            class: "uploaded-img",
                            width: 156,
                            height: 88,
                            "aspect-ratio": "16/9",
                            cover: "",
                            src: attachment?.uploadedImages?.url
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("h5", null, _toDisplayString(attachment?.uploadedImages?.name), 1),
                            _createVNode(_component_v_btn, {
                              onClick: ($event: any) => (
                        $setup.removeImageFromAttachments(
                          index,
                          attachment?.uploadedImages?.attachmentId
                        )
                      ),
                              variant: "text",
                              class: "button button-lightGray"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_v_select, {
                              modelValue: attachment.propertyId,
                              "onUpdate:modelValue": ($event: any) => ((attachment.propertyId) = $event),
                              label: "Select property",
                              items: $setup.projectProperties,
                              rules: $setup.validation.property,
                              "item-title": "address",
                              "item-value": "id",
                              multiple: "",
                              variant: "outlined",
                              density: "compact",
                              class: "selectprop_dropdown",
                              "menu-props": { contentClass: 'dropdown__selector' }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"]),
                            _createVNode(_component_v_select, {
                              modelValue: attachment.taskId,
                              "onUpdate:modelValue": ($event: any) => ((attachment.taskId) = $event),
                              label: "Select Task",
                              items: $props.phaseDetails.estimationPhaseTasks,
                              "item-title": "name",
                              "item-value": "id",
                              variant: "outlined",
                              density: "compact",
                              class: "selectprop_dropdown",
                              "menu-props": { contentClass: 'dropdown__selector' }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_CommonLoader, {
                  loading: $setup.isLoading,
                  class: "loader-container"
                }, null, 8, ["loading"])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_v_btn, {
          class: "button button-purple-border",
          onClick: $setup.onClickToggleAttachmentModal,
          variant: "outlined",
          disabled: $setup.isLoadingUploadAttachments
        }, {
          default: _withCtx(() => [
            _createTextVNode(" cancel ")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          loading: $setup.isLoadingUploadAttachments,
          disabled: $setup.isLoading,
          onClick: $setup.onClickSaveButtonAttachmentsModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(" save ")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ])
    ]),
    _: 1
  }))
}